<div
	class="w-full divide-y divide-gray-100 cursor-auto"
	(click)="$event.stopPropagation()"
>
	@if (searchResultLength() > 0) {
	<div class="flex gap-2 py-2">
		<div class="relative">
			<button
				type="button"
				class="relative inline-flex items-center whitespace-nowrap rounded-full bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3"
				[ngClass]="{
					'bg-primary-600 text-white hover:bg-primary-500':
						activeSearchType === 'All'
				}"
				(click)="getSearchItems('All')"
			>
				<div
					class="hidden truncate sm:block"
					[class.text-white.font-medium]="activeSearchType === 'All'"
				>
					<span class="mr-2">All</span>
					<span
						class="rounded-full text-[12px] font-bold p-1"
						>{{ searchResultItemLength() }}</span
					>
				</div>
			</button>
		</div>
		@for (categories of results(); track categories) {
		<div class="relative">
			<button
				type="button"
				class="relative inline-flex items-center whitespace-nowrap rounded-full bg-gray-50 px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-100 sm:px-3"
				[ngClass]="{
					'bg-primary-600 text-white hover:bg-primary-500':
						activeSearchType === categories.referenceType
				}"
				(click)="getSearchItems(categories.referenceType)"
			>
				@switch (categories.referenceType) {
				<!-- Claims -->
				@case ('Claims') {
				<mat-icon
					class="icon-size-5 flex-shrink-0 text-gray-500 sm:-ml-1"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
					svgIcon="heroicons_outline:briefcase"
				></mat-icon>
				}
				<!-- Contacts -->
				@case ('Contacts') {
				<mat-icon
					class="icon-size-5 flex-shrink-0 text-gray-500 sm:-ml-1"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
					svgIcon="heroicons_outline:user-group"
				></mat-icon>
				}
				<!-- Users -->
				@case ('Users') {
				<mat-icon
					class="icon-size-5 flex-shrink-0 text-gray-500 sm:-ml-1"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
					svgIcon="heroicons_outline:user"
				></mat-icon>
				}
				<!-- Leads -->
				@case ('Leads') {
				<mat-icon
					class="icon-size-5 flex-shrink-0 text-gray-500 sm:-ml-1"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
					svgIcon="heroicons_outline:inbox-arrow-down"
				></mat-icon>
				}
				<!-- Companies -->
				@case ('Companies') {
				<mat-icon
					class="icon-size-5 flex-shrink-0 text-gray-500 sm:-ml-1"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
					svgIcon="heroicons_outline:building-office"
				></mat-icon>
				} }
				<div
					class="hidden truncate sm:block font-medium sm:ml-2"
					[class.text-white.font-medium]="
						activeSearchType === categories.referenceType
					"
				>
					<span class="mr-2">{{ categories.referenceType }}</span>
					<span
						class="rounded-full text-[12px] font-bold p-1"
						>{{ categories.items.length }}</span
					>
				</div>
			</button>
		</div>
		}
	</div>
	<div class="flex divide-x divide-gray-100">
		<div
			class="max-h-96 min-w-0 flex-auto scroll-py-4 overflow-y-auto px-6 py-4 sm:h-96"
		>
			<ul class="-mx-2 text-sm text-gray-700" id="recent" role="listbox">
				@for (item of searchItems; track item) {
				<li
					class="group flex cursor-default select-none items-center rounded-md p-2 h-10 hover:bg-gray-100 text-gray-900"
					[class.bg-gray-100.text-gray-900]="
						item.referenceId == searchItem?.referenceId &&
						item.referenceType == searchItem?.referenceType
					"
					id="recent-1"
					role="option"
					tabindex="-1"
					(mouseenter)="onMouseEnter(item)"
				>
					@switch (item.referenceType) {
					<!-- Claims -->
					@case ('Claims') {
					<mat-icon
						class="icon-size-4 flex-shrink-0 text-gray-500 sm:-ml-1"
						svgIcon="heroicons_outline:briefcase"
					></mat-icon>
					}
					<!-- Contacts -->
					@case ('Contacts') {
					<mat-icon
						class="icon-size-4 flex-shrink-0 text-gray-500 sm:-ml-1"
						svgIcon="heroicons_outline:user-group"
					></mat-icon>
					}
					<!-- Users -->
					@case ('Users') {
					<mat-icon
						class="icon-size-4 flex-shrink-0 text-gray-500 sm:-ml-1"
						svgIcon="heroicons_outline:user"
					></mat-icon>
					}
					<!-- Leads -->
					@case ('Leads') {
					<mat-icon
						class="icon-size-4 flex-shrink-0 text-gray-500 sm:-ml-1"
						svgIcon="heroicons_outline:inbox-arrow-down"
					></mat-icon>
					}
					<!-- Companies -->
					@case ('Companies') {
					<mat-icon
						class="icon-size-4 flex-shrink-0 text-gray-500 sm:-ml-1"
						svgIcon="heroicons_outline:building-office"
					></mat-icon>
					} }

					<span class="ml-3 flex-auto truncate">{{
						item.title
					}}</span>
					<mat-icon
						class="ml-3 icon-size-5 flex-none text-gray-400 group-hover:block"
						[class.block]="
							item.referenceId == searchItem?.referenceId &&
							item.referenceType == searchItem?.referenceType
						"
						[class.hidden]="
							item.referenceId != searchItem?.referenceId ||
							item.referenceType != searchItem?.referenceType
						"
						svgIcon="mat_outline:keyboard_arrow_right"
					></mat-icon>
				</li>
				}
			</ul>
		</div>
		@if (searchItem) {
		<div
			class="hidden h-96 w-2/3 flex-none flex-col divide-y divide-gray-100 sm:flex p-4"
		>
			@if (searchItem?.quickActionContent) {
			<div class="flex-1 overflow-x-hidden overflow-y-auto">
				@switch (searchItem.referenceType) { @case ('Claims') {
				<cm-quick-view-claim
					[quickAction]="searchItem.quickActionContent"
					(onClose)="onClose.emit(null)"
				></cm-quick-view-claim>
				} @case ('Companies') {
				<cm-quick-view-company
					[quickAction]="searchItem.quickActionContent"
				>
				</cm-quick-view-company>
				} @case ('Contacts') {
				<cm-quick-view-contact
					[quickAction]="searchItem.quickActionContent"
					(onClose)="onClose.emit(null)"
				></cm-quick-view-contact>
				} @case ('Users') {
				<cm-quick-view-contact
					[quickAction]="searchItem.quickActionContent"
				></cm-quick-view-contact>
				} @case ('Leads') {
				<cm-quick-view-lead
					[quickAction]="searchItem.quickActionContent"
				></cm-quick-view-lead>
				} @case ('Users') {
				<cm-quick-view-user
					[quickAction]="searchItem.quickActionContent"
					(onClose)="onClose.emit(null)"
				></cm-quick-view-user>
				} }
			</div>
			<button
				type="button"
				class="mt-4 w-full rounded-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
				(click)="goToPage()"
			>
				@switch (searchItem.referenceType) { @case ('Claims') { Go to
				claim } @case ('Companies') { Go to company } @case ('Contacts')
				{ Go to contact } @case ('Users') { Go to contact } @case
				('Leads') { Go to lead } }
			</button>
			} @else {
			<div class="px-6 hide py-14 text-center text-sm sm:px-14">
				<mat-icon
					svgIcon="heroicons_outline:viewfinder-circle"
				></mat-icon>
				<p class="mt-4 font-semibold text-gray-900">
					No quick action found
				</p>
			</div>
			}
		</div>
		}
	</div>
	} @else {
	<div class="px-6 py-14 text-center text-sm sm:px-14">
		<mat-icon svgIcon="heroicons_outline:user-group"></mat-icon>
		<p class="mt-4 font-semibold text-gray-900">No item found</p>
		<p class="mt-2 text-gray-500">
			We couldn’t find anything with that term. Please try again.
		</p>
	</div>
	}
</div>
